import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AROON',
  version: 1,
  label: 'Aroon',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 140,
  inputs: [period('timeperiod', 14)],
  outputs: [line('aroonup', 'Aroon Up', COLOR.green), line('aroondown', 'Aroon Down', COLOR.red)],
  talib: {
    functions: ['AROON'],
    expr: 'AROON(high, low, timeperiod={timeperiod})',
    outputs: { aroonup: 'aroonup', aroondown: 'aroondown' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
